import { render, staticRenderFns } from "./creation.vue?vue&type=template&id=b15d1308&scoped=true&"
import script from "./creation.vue?vue&type=script&lang=js&"
export * from "./creation.vue?vue&type=script&lang=js&"
import style0 from "./creation.vue?vue&type=style&index=0&id=b15d1308&prod&lang=scss&scoped=true&"
import style1 from "./creation.vue?vue&type=style&index=1&id=b15d1308&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b15d1308",
  null
  
)

export default component.exports